import axios from "axios";
import TokenService from "./Base/Services/TokenService";

export const AuthHttp = axios.create();

const AxiosConfig = {
  init: () => {
    axios.interceptors.request.use((config) => {
      // Always add the content-type header if not already on the request
      if (!config.headers["content-type"]) {
        config.headers["content-type"] = "application/json";
      }
      // Always add the auth header to requests if not already present
      const accessToken = TokenService.getStoredToken();
      if (accessToken && !config.headers["Authorization"]) {
        // Auth tokens are placed in the Authorization header with the prefix: Bearer
        config.headers["Authorization"] = "Bearer " + accessToken;
      }
      return config;
    });

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error?.response?.status === 401) {
          // A 401 error means that the access token has likely expired. Try to refresh it!
          return TokenService.attemptTokenRefresh()
            .then(() => {
              // Repeat the request again with the updated token & no new base url
              // https://stackoverflow.com/questions/51563821/axios-interceptors-retry-original-request-and-access-original-promise
              const accessToken = TokenService.getStoredToken();
              error.config.headers["Authorization"] = "Bearer " + accessToken;
              error.baseURL = undefined;
              return axios.request(error.config);
            })
            .catch((e) => {
              alert("Your session has expired for security reasons");
              TokenService.clearStoredTokens();
              window.location.href = "/";
            });
        } else if (!error || !error.response) {
          console.error(error);
          alert(
            "There was an error completing your request - due to network errors, this page may not have loaded correctly and/or your changes may not be saved. Try reloading the page or contact your administrator if the problem continues."
          );
        } else {
          return Promise.reject(error);
        }
      }
    );
  },
};
export default AxiosConfig;
